import { createSelector } from 'reselect';
import { SchemeEditorStore } from '@modules/planning/children/scheme-editor/types';

export const isFetchingSelector = createSelector(
  (state: SchemeEditorStore) => state.PlannerSchemeEditor.isFetching,
  (isFetching: boolean) => isFetching
);
